import React, { useEffect } from 'react';

import { useRouteError } from 'react-router';

import Paragraph from '@af-fp/components/typography/Paragraph';
import SectionHeader from '@af-fp/components/typography/SectionHeader';
import { reloadPage } from '@af-fp/util/reload-page';

/**
 * Last-resort full-page fallback for the root route. Depends on no context providers, since
 * the failure may have originated in one of them.
 */
export const GlobalErrorBoundary: React.FC = () => {
  const error = useRouteError();

  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div
      role='alert'
      className='bg-bgcolor-300 text-textcolor flex h-screen w-screen flex-col items-center justify-center gap-4 px-6 text-center font-sans'
    >
      <SectionHeader>Something went wrong</SectionHeader>
      <Paragraph>An unexpected error occurred. Please reload the page, or return to the home page.</Paragraph>
      <div className='flex flex-row gap-4'>
        <button
          type='button'
          className='bg-primary-500 hover:bg-primary-800 text-bgcolor-300 cursor-pointer px-5 py-4 leading-none'
          onClick={reloadPage}
        >
          Reload page
        </button>
        <a href='/' className='bg-secondary-500 hover:bg-secondary-800 text-bgcolor-300 px-5 py-4 leading-none'>
          Go home
        </a>
      </div>
    </div>
  );
};
